var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// eslint-disable-next-line no-restricted-syntax
import 'react-calendar-heatmap/dist/styles.css';
import { classNames, getHeatmapColorByDirectMatch } from '@web/utility';
import { formatIsoDateForPlainTooltip } from '@web/utility/ tooltip/tooltipDateLabel';
import React from 'react';
import CalendarHeatmap from 'react-calendar-heatmap';
import { useTranslation } from 'react-i18next';
import { Tooltip as ReactTooltip } from 'react-tooltip';
var textColorToBgClass = function (textClass) {
    return textClass.replace(/^text-/, 'bg-');
};
var Heatmap = function (_a) {
    var title = _a.title, values = _a.values, _b = _a.customClassNames, customClassNames = _b === void 0 ? '' : _b, legends = _a.legends, _c = _a.onCellClick, onCellClick = _c === void 0 ? function () { } : _c, _d = _a.clickable, clickable = _d === void 0 ? true : _d, customColorIntensity = _a.colorIntensity, _e = _a.useDirectColorMatch, useDirectColorMatch = _e === void 0 ? false : _e, formatTooltipHtmlContent = _a.formatTooltipHtmlContent, _f = _a.showIntensityLegend, showIntensityLegend = _f === void 0 ? false : _f;
    var t = useTranslation().t;
    var arrayOfCounts = values.map(function (item) { return item.count; });
    var uniqueValues = new Set(arrayOfCounts.sort(function (a, b) { return a - b; }).reverse());
    var defaultColorIntensity = [
        { id: 1, color: 'text-green-50' },
        { id: 2, color: 'text-green-100' },
        { id: 3, color: 'text-green-200' },
        { id: 4, color: 'text-green-400' },
        { id: 5, color: 'text-green-600' },
        { id: 6, color: 'text-green-700' },
        { id: 7, color: 'text-green-800' }
    ];
    var colorIntensity = customColorIntensity || defaultColorIntensity;
    var kof = colorIntensity.length / (uniqueValues.size - 1);
    var getColor = function (data, target) {
        return data.reduce(function (acc, obj) {
            return Math.abs(target * kof - obj.id) < Math.abs(target * kof - acc.id)
                ? obj
                : acc;
        });
    };
    var generateClassName = function (count) {
        return classNames('fill-current outline-none', clickable && 'cursor-pointer', count);
    };
    var setColor = function (count) {
        var colorObj = useDirectColorMatch
            ? getHeatmapColorByDirectMatch(colorIntensity, count)
            : getColor(colorIntensity, count);
        return generateClassName(colorObj.color);
    };
    if (values.length === 0) {
        return null;
    }
    var classForValue = function (value) {
        if (!value || !value.count) {
            return classNames('color-empty outline-none', clickable && 'cursor-pointer');
        }
        if (value.customClassColor) {
            return classNames('fill-current outline-none', clickable && 'cursor-pointer', value.customClassColor);
        }
        return setColor(value.count);
    };
    var tooltipDataAttrs = function (value) {
        if (!value || !value.date)
            return {};
        var count = value.count || 0;
        if (formatTooltipHtmlContent) {
            return {
                'data-tooltip-id': 'heatmap-tooltip',
                'data-tooltip-html': formatTooltipHtmlContent(value.date, count)
            };
        }
        return {
            'data-tooltip-id': 'heatmap-tooltip',
            'data-tooltip-content': "".concat(formatIsoDateForPlainTooltip(value.date), ": ").concat(count)
        };
    };
    return (_jsxs("div", __assign({ className: classNames('h-full', customClassNames) }, { children: [title ? (_jsx("div", __assign({ className: "flex items-center justify-between mb-3" }, { children: _jsx("div", { children: _jsx("h2", __assign({ className: "text-xl leading-7 font-semibold text-gray-900 inline-block" }, { children: title })) }) }))) : null, showIntensityLegend ? (_jsxs("div", __assign({ className: "mb-3 flex items-center gap-2 text-sm text-gray-500" }, { children: [_jsx("span", { children: t('heatmap.lessActivity') }), _jsxs("div", __assign({ className: "flex items-center gap-0.5" }, { children: [_jsx("span", { className: "h-3 w-3", style: { backgroundColor: '#eeeeee' } }), colorIntensity.map(function (_a) {
                                var id = _a.id, color = _a.color;
                                return (_jsx("span", { className: classNames('h-3 w-3', textColorToBgClass(color)) }, id));
                            })] })), _jsx("span", { children: t('heatmap.moreActivity') })] }))) : null, _jsx("div", __assign({ className: "overflow-x-auto" }, { children: _jsx("div", __assign({ className: "min-w-[600px] overflow-x-auto" }, { children: _jsx(CalendarHeatmap, { startDate: new Date(new Date().setFullYear(new Date().getFullYear() - 1)), endDate: new Date(), values: values, showOutOfRangeDays: false, classForValue: classForValue, tooltipDataAttrs: tooltipDataAttrs, weekdayLabels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'], showWeekdayLabels: true, onClick: onCellClick }) })) })), legends ? (_jsx("div", __assign({ className: "flex mt-3 justify-center" }, { children: legends.map(function (legend, i) { return (_jsxs("div", __assign({ className: "flex clear-right mr-5" }, { children: [_jsx("span", { className: "block w-4 h-4 mt-1 mr-2 rounded-full", style: { backgroundColor: legend.color } }), legend.label] }), i)); }) }))) : null, _jsx(ReactTooltip, { id: "heatmap-tooltip" })] })));
};
export default Heatmap;
